import Vue from 'vue'
import App from './App.vue'
import vuetify from 'vuetify'
import './assets/css/style.styl'
import router from './router'
import VueCookies from 'vue-cookies'

Vue.use(vuetify, {
  theme: {
    primary: '#DF1B12',
    accent: '#DF1B12'
  }
})

Vue.use(VueCookies)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')